import axios from 'axios'
import API_URL from '@/router/api'
import * as types from './mutation-types'

export const create = (ctx, form) => {
    return new Promise((resolve, reject) => {

        axios.post(API_URL.payout.createPayout, form)
            .then(res => {
                getPendingCount(ctx)
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const getPendingCount = (ctx, query = {}) => {
    return new Promise((resolve, reject) => {

        axios.get(API_URL.payout.getPendingCount, { params: query })
            .then(res => {
                ctx.commit(types.SET_TOTAL_PAYOUT, res.data.data.total)
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
